<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 mt-2 pb-2 bgsecond">

                <div class="row   text-light">

                    <div class="col-md-10 offset-1">

                        <div class="row ">
                            <h1 class=" mt-1 col-md-4 offset-5">
                                <span v-if="actiontype=='Save'">Add</span>
                                <span v-if="actiontype=='Update'">Update</span>
                                 Franchise </h1>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Franchise Name <span class="text-danger">*</span></label>
                                <b-form-input v-model="form.f_name" placeholder="Enter franchise name"></b-form-input>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Legal Company Name</label>
                                <b-form-input v-model="form.f_legalCompanyName" placeholder="Enter legal company name"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Branch Name (Invoice)</label>
                                <b-form-input v-model="form.f_branchNameInvoice" placeholder="Enter branch name for invoice"></b-form-input>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Status</label>
                                <v-select
                                    v-model="form.status"
                                    class="text-dark"
                                    placeholder="Select Status"
                                    :options="['Pending','Active','Inactive']"
                                />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-3">
                                <label for="" class="form-label">Royalties %</label>
                                <b-form-input v-model="form.f_royalities_percentage" type="number" step="0.01" placeholder="0.00"></b-form-input>
                            </div>
                            <div class="col-md-3">
                                <label for="" class="form-label">Cost Margin %</label>
                                <b-form-input v-model="form.f_costMarginPercent" type="number" step="0.01" placeholder="0.00"></b-form-input>
                            </div>
                            <div class="col-md-3">
                                <label for="" class="form-label">Shipping Margin %</label>
                                <b-form-input v-model="form.f_shippingMarginPercent" type="number" step="0.01" placeholder="0.00"></b-form-input>
                            </div>
                            <div class="col-md-3">
                                <label for="" class="form-label">Collection Fix Rate(£)</label>
                                <b-form-input v-model="form.f_collectionFixRate" type="number" step="0.01" placeholder="0.00"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-3">
                                <label for="" class="form-label">Due Days</label>
                                <b-form-input v-model="form.f_dueDays" type="number" placeholder="0"></b-form-input>
                            </div>
                        </div>

                        <hr class="bg-light" />

                        <div class="row mt-3">
                            <h5 class="col-md-12">Address Details</h5>
                        </div>

                        <div class="row mt-2">
                            <div class="col-md-6">
                                <label for="" class="form-label">Address Line 1</label>
                                <b-form-input v-model="form.addressLine1" placeholder="Enter address line 1"></b-form-input>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Address Line 2</label>
                                <b-form-input v-model="form.addressLine2" placeholder="Enter address line 2"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-4">
                                <label for="" class="form-label">State</label>
                                <b-form-input v-model="form.state" placeholder="Enter state"></b-form-input>
                            </div>
                            <div class="col-md-4">
                                <label for="" class="form-label">Postcode</label>
                                <b-form-input v-model="form.postcode" placeholder="Enter postcode"></b-form-input>
                            </div>
                            <div class="col-md-4">
                                <label for="" class="form-label">Tel</label>
                                <b-form-input v-model="form.tel" placeholder="Enter telephone"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Email</label>
                                <b-form-input v-model="form.email" type="email" placeholder="Enter email"></b-form-input>
                            </div>
                        </div>

                        <div class="row " style="margin-top: 40px;">
                            <div class="col-md-4 offset-4">
                                <button  type="button" class="btn custom-btn2 w-100 btn-lg text-light   mt-5 mtmb" @click="save_franchisee" :disabled="saving || fetching "> <span v-if="actiontype=='Update'" >Update</span>  <span v-if="actiontype=='Save'">Save</span> </button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import apiService from "@/service/apiService";
import {mapActions, mapState} from "vuex";
import { mapGetters } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import axios from "axios";
import {cloneDeep} from "lodash";
import Swal from "sweetalert2";
import showrealtime from "@/components/showrealtime";
import URL from "@/constants/baseurl"
import Welcomenote from "@/pages/admin/mypos/welcomenote";
import vSelect from "vue-select";


export default {
    name: "franchise detail form",

    components:{Welcomenote, 'v-select': vSelect, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        actiontype(){
            if (this.$route.query.type=='add'){
                return 'Save'
            }
            else if (this.$route.query.type=='edit'){
                return 'Update'
            }
            else {
                return 'View'
            }
        }

    },
    data() {
        return {
            form:{
                f_name:'',
                f_legalCompanyName:'',
                f_branchNameInvoice:'',
                f_royalities_percentage:'',
                f_costMarginPercent:'',
                f_shippingMarginPercent:'',
                f_collectionFixRate:'',
                f_dueDays:'',
                status:'Active',
                addressLine1:'',
                addressLine2:'',
                state:'',
                postcode:'',
                tel:'',
                email:'',
            },
            saving:false,
            fetching:false,

        };
    },
    async created() {
        this.viewType = this.$route.query.type;
        this.franchisee_id = this.$route.query.id;
        this.setFranchisee()

    },
    async mounted() {

    },

    methods: {
        ...mapActions(['login', 'processLogoutManual']),

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },

        async save_franchisee() {
            if (!this.form.f_name) {
                Swal.fire('Error', 'Franchise Name is required.', 'error');
                return;
            }

            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }

            this.saving=true
            try {
                let api_url=`${URL.BASEURL}/api/add-franchisee`
                if(this.franchisee_id){
                    api_url=`${URL.BASEURL}/api/update-franchisee/${this.franchisee_id}`
                }
                const response = await axios.post(api_url, this.form);

                if(this.franchisee_id){
                    await Swal.fire('Success', 'Franchise updated successfully!', 'success');
                } else {
                    await Swal.fire('Success', 'Franchise created successfully!', 'success');
                }

                this.$router.push({ path: '/franchise-management' })

            } catch (error) {
                console.error("Error saving franchise:", error);
                Swal.fire('Error', 'Failed to save franchise.', 'error');
            }
            finally {
                this.saving=false
            }
        },

        async setFranchisee(){
            if(this.viewType!=='add'){
                this.fetching=true
                const {data} = await apiService.get(`/get-franchisee/${this.franchisee_id}`);

                this.form.f_name=data.f_name;
                this.form.f_legalCompanyName=data.f_legalCompanyName;
                this.form.f_branchNameInvoice=data.f_branchNameInvoice;
                this.form.f_royalities_percentage=data.f_royalities_percentage;
                this.form.f_costMarginPercent=data.f_costMarginPercent;
                this.form.f_shippingMarginPercent=data.f_shippingMarginPercent;
                this.form.f_collectionFixRate=data.f_collectionFixRate;
                this.form.f_dueDays=data.f_dueDays;
                this.form.status=data.status;
                this.form.addressLine1=data.addressLine1;
                this.form.addressLine2=data.addressLine2;
                this.form.state=data.state;
                this.form.postcode=data.postcode;
                this.form.tel=data.tel;
                this.form.email=data.email;

                this.fetching=false

            }
        },
    }
};
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}

</style>
